// extracted by mini-css-extract-plugin
module.exports = {"code":"Code_code__3qR-A","message":"Code_message__1znfa"};